import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  makeStyles, Typography, Box, Modal, Button, Snackbar, Grid
} from '@material-ui/core';

import { addItemToArray, api_call, console_log, empty, getDeviceGalleryUrl, getDeviceImageUri, get_data_value, get_utc_timestamp_ms } from '../helpers/untils';
import ImageUploadBox from '../components/ImageUploadBox';
import { layoutActions } from "../store";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '800px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
};

const modalInnerStyle = {
  position: 'relative',
  width: '100%',
  maxHeight: 'calc(100vh - 160px)',
  overflowY: 'auto',
  padding: '8px'
};

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '30%',
    },
  },
  avatar: {
    width: '100%',
    maxWidth: '250px',
    height: 'auto',
    cursor: 'pointer',
  },

}));

const DeviceImageUploadModal = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const user = useSelector((state) => state.session.user);
  const { open, setOpen, item, setItem } = props;

  const imageFieldList = [
    {
      fieldName: "icon",
      title: "Icon"
    },
    {
      fieldName: "front_car",
      title: "Front Of Car"
    },
    {
      fieldName: "driver_side",
      title: "Driver Side"
    },
    {
      fieldName: "passenger_side",
      title: "Passenger Side"
    },
    {
      fieldName: "back_car",
      title: "Back Of Car"
    },
    {
      fieldName: "instrument_cluster",
      title: "Instrument Cluster"
    }
  ]

  const [imageData, setImageData] = useState({})
  const [deletedImages, setDeletedImages] = useState([])
  const [galleryUrls, setGalleryUrls] = useState({})

  useEffect(() => {
    if (open) {
      setDeletedImages([])
      setImageData({})
    }
    if (item.gallery) {
      const galleryObj = JSON.parse(item.gallery)
      const gallery_urls = getDeviceGalleryUrl(galleryObj, false)
      setGalleryUrls(gallery_urls)
    } else {
      setGalleryUrls([])
    }
  }, [open, item]);

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [apiLoading, setApiLoading] = useState(false)

  const onClickSaveBtn = async () => {
    const url = `/api/devices/uploadDeviceImages`;
    var formData = new FormData();
    formData.append("user_id", user.id);
    formData.append("device_id", item.id);
    for (let k in imageData) {
      formData.append(k, imageData[k]);
    }
    formData.append("deletedImages", JSON.stringify(deletedImages))

    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      body: formData,
    });

    setApiLoading(false)
    if (response.ok) {
      const apiData = await response.json()
      setItem(apiData['device'])
      setToastMessage(`Device image has been updated successfully`);
      setSnackbarOpen(true);
      dispatch(
        layoutActions.setDeviceReloadTimestamp({
          value: get_utc_timestamp_ms(),
        })
      );

      setTimeout(() => {
        setSnackbarOpen(false);
        handleModalClose()
      }, 1500)

    } else {
      const apiError = response
      console_log("apiError:::", apiError)
      if (apiError.error) {
        setToastMessage(apiError.error);
      }
      setSnackbarOpen(true);
    }
  }

  const onChangeImage = (fieldName, fileObj) => {
    console.log(`fieldName, fileObj:::`, fieldName, fileObj)
    const image_data = { ...imageData }
    image_data[fieldName] = fileObj
    setImageData(image_data)
    if (fileObj === null) {
      console.log(`setDeletedImages::::`, fieldName)
      setDeletedImages(addItemToArray([...deletedImages], fieldName))
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Box sx={modalInnerStyle}>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={snackbarOpen}
              onClose={() => { setSnackbarOpen(false) }}
              autoHideDuration={1500}
              message={toastMessage}
            />
            <Typography>Upload device image</Typography>

            <div className='mt-4'>
              <Grid container spacing={2}>
                {
                  imageFieldList.map((item) => {
                    return (
                      <Grid item xs={12} md={6} key={item.fieldName}>
                        <ImageUploadBox
                          title={item.title}
                          fieldName={item.fieldName}
                          onChangeImage={(fieldName, file) => onChangeImage(fieldName, file)}
                          galleryUrl={get_data_value(galleryUrls, item.fieldName)}
                        />
                      </Grid>
                    )
                  })
                }
              </Grid>
            </div>

            <div className='mt-4'>
              <div className={classes.buttons} style={{ width: '100%', margin: 'auto' }}>
                {/* <Button type="button" color="primary" variant="contained" onClick={() => onClickFileBtn()} disabled={apiLoading}>
                Choose File
              </Button> */}
                <Button type="button" color="primary" variant="contained" onClick={() => onClickSaveBtn()} disabled={apiLoading}>
                  Submit
                </Button>
                <Button type="button" color="primary" variant="outlined" onClick={() => setOpen(false)}>
                  Close
                </Button>
              </div>
            </div>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeviceImageUploadModal;
